<template>
  <div class="container">
    <div class="flex justify-center">
      <div class="w-full xl:w-2/3">
        <SubmissionProgress />
        <div class="py-8">
          <div class="flex flex-col justify-center items-center">
            <TickThick
              width="4rem"
              height="4rem"
              class="fill-lime" />
            <h1 class="font-bitter text-3xl text-center font-bold my-4">
              All done!
            </h1>
            <p class="mb-4 text-center">
              You have successfully submitted your manuscript to Chemical Science.
            </p>
          </div>
          <SubmissionFeedback />
          <h2 class="font-roboto text-2xl font-bold border-b border-royal-blue-20 pb-4 mb-4">
            What's next?
          </h2>
          <ol class="list-decimal mb-4 pl-4">
            <li class="mb-4">
              We will email the corresponding author with a confirmation that we have received your
              submission.
            </li>
            <li class="mb-4">
              We will check that we have all the correct information to support your submission.
            </li>
            <li class="mb-4">
              Each author listed on the manuscript will be sent a confirmation email from ScholarOne once the files have
              been confirmed.
              <em>Please note that this may take up to 3 days over a weekend.</em>
            </li>
            <li class="mb-4">
              Your manuscript will be passed on to the Chemical Science editorial team for initial
              assessment on scope and suitability for the journal.
            </li>
          </ol>
        </div>
        <SupportInfo />
      </div>
    </div>
  </div>

  <div class="bg-science-blue-5 py-8 mb-8">
    <div class="container">
      <div
        data-testid="join-digital-research-lab-content"
        class="flex justify-center">
        <div class="w-full xl:w-2/3">
          <h2 class="font-roboto text-2xl font-bold mb-4">
            Help us to help you
          </h2>
          <p class="mb-4">
            Join our effort to improve the tools and services you use as a researcher and author. By joining Digital Research Lab, you can help test developing ideas, share feedback and more. Simply complete a short survey, and we'll keep you updated on activities you can participate in.
          </p>
          <a
            href="https://www.smartsurvey.co.uk/s/rsc_manuscript-submission_invite"
            target="_blank"
            rel="noopener noreferrer"
            class="inline-block px-6 py-2.5 bg-royal-blue-100 border-royal-blue-100 border-2 text-white rounded-sm relative hover:bg-royal-blue-160 hover:border-royal-blue-160 focus:bg-science-blue-100 focus:border-science-blue-100">
            Join now
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import SubmissionFeedback from '../components/SubmissionFeedback.vue'
import SubmissionProgress from '../components/progress/SubmissionProgress.vue'
import TickThick from '../images/svg/TickSvg.vue'
import { useStore } from 'vuex'
import { onBeforeRouteLeave } from 'vue-router'
import SupportInfo from '@/components/common/SupportInfo.vue'

const store = useStore()

onMounted(() => {
  store.commit('clearSubmission')
})

onBeforeRouteLeave((to, _, next) => {
  if (!to.meta?.step) {
    next()
  }
  else {
    next(false)
  }
})</script>
